/** What a store sells, asked at signup. Values match the API's BusinessCategory choices. */
export const BUSINESS_CATEGORIES = [
  { value: "FASHION_APPAREL", label: "Fashion & Apparel" },
  { value: "HAIR_BEAUTY", label: "Hair & Wigs / Beauty" },
  { value: "SHOES_BAGS", label: "Shoes & Bags" },
  { value: "FOOD_PASTRIES", label: "Food & Pastries" },
  { value: "GADGETS_ELECTRONICS", label: "Gadgets & Electronics" },
  { value: "HOME_LIFESTYLE", label: "Home & Lifestyle" },
  { value: "OTHERS", label: "Others" },
] as const;

export type BusinessCategory = (typeof BUSINESS_CATEGORIES)[number]["value"];
